import { PeerReference, PeerReferenceRequest } from '~/types';
import { PeerRequestFormValues } from './types';

export const transformFormValuesToPeerRefRequest = (formValues: PeerRequestFormValues): string => {
  const peerReq: Partial<PeerReferenceRequest> = {
    ...formValues,
    relationshipType: formValues.relationshipType.value as PeerReferenceRequest['relationshipType'],
  };
  return JSON.stringify(peerReq);
};

export const transformPeerReferenceToFormValues = (peerRef: string): PeerRequestFormValues => {
  const parsed: PeerReference = JSON.parse(peerRef);
  return {
    ...parsed,
    relationshipType: {
      label: parsed.relationshipType,
      value: parsed.relationshipType,
    },
  };
};
